import styled from 'styled-components';

export const Container = styled.div`
  min-height: calc(100vh - 56px);
  padding: 40px 16px;
  background: ${(props) => props.theme.$gray100};
`;

// Cores do componente "Aviso-validação" do Figma (não há token equivalente no tema)
export const ValidationNotice = styled.div`
  max-width: 1152px;
  margin: 0 auto 24px;
  padding: 8px;
  background: #fdf3d1;
  border: 1px solid #fceec0;
  border-radius: 4px;
  color: #80651f;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.32px;
`;

export const Content = styled.div`
  max-width: 1020px;
  margin: 0 auto;
`;

export const VideoPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 559px;
  margin-bottom: 40px;
  background: ${(props) => props.theme.$dark};
  border-radius: 8px;
  color: ${(props) => props.theme.$white};
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.48px;

  @media only screen and (max-width: 768px) {
    height: 240px;
  }
`;

export const Title = styled.h2`
  margin-bottom: 16px;
  color: ${(props) => props.theme.$black};
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.48px;
`;

export const Description = styled.p`
  margin-bottom: 19px;
  color: ${(props) => props.theme.$black};
  font-size: 16px;
  line-height: 1.2;
  letter-spacing: -0.32px;

  &:last-of-type {
    margin-bottom: 16px;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;

  .btn {
    padding: 8px 16px;
    font-size: 16px;
    line-height: 1.2;
    letter-spacing: -0.32px;
  }
`;
